<!--
Use ngx-loading-bar/http-client when load this page.
-->
<ngx-loading-bar [color]="'white'"></ngx-loading-bar>
<!-- / -->
<p-toast position="center"></p-toast>

<main class="w-full px-4">
  <div class="mx-auto max-w-7xl">
    <!-- Breadcrumbs -->
    <nav class="flex mt-12" aria-label="Breadcrumb">
      <ol role="list" class="flex items-center space-x-4">
        <li>
          <div>
            <a [routerLink]="['/']" class="text-gray-400 hover:text-pink-800">
              <svg class="h-5 w-5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z" clip-rule="evenodd" />
              </svg>
              <span class="sr-only">Início</span>
            </a>
          </div>
        </li>

        <li>
          <div class="flex items-center">
            <svg class="h-5 w-5 flex-shrink-0 text-pink-800" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
              <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
            </svg>
            <a class="ml-4 text-sm font-medium text-gray-500 hover:text-pink-800" aria-current="page">Marcas</a>
          </div>
        </li>
      </ol>
    </nav>

    <div class="py-20">
      <div class="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-8 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-2">
        <ng-container *ngFor="let man of salesman?.data">
          <div class="border-t border-b border-gray-200 bg-white shadow-sm sm:rounded-lg sm:border">
            <div class="p-4">
              <ng-container *ngIf="man.url_banner_header != ''">
                <img class="aspect-video rounded-2xl object-contain" src="{{man.url_banner_header}}" alt="{{man.name}}" />
              </ng-container>
              <h3 class="mt-6 text-lg font-semibold leading-8 tracking-tight text-gray-700">{{man.name}}</h3>
              <p class="text-sm text-gray-600">{{man.body_description_short}}</p>
              <div class="flex gap-x-6 mt-5">
                <a [routerLink]="['/s/salesman/'+man.name]" class="rounded-md bg-pink-800 py-2 px-3 text-sm font-semibold text-white shadow-sm hover:bg-pink-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-800">Produtos {{man.name}}</a>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</main>
